var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications'),(!_vm.$store.state.viewStore)?_c('div',[_c('router-view')],1):[_c('StoreHeader'),_c('router-view',{staticClass:"h-100"}),_c('StoreCartLateral'),_c('WhatsAppButton'),_c('StoreFooter')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }